import { FieldProps } from "../../renderFieldInput";
import { Controller, get } from "react-hook-form";
import { useUrlParamValue } from "../../../../utils/useUrlParamValue";
import { TextField } from "@mui/material";

type OperationsStaffAgreementInputFieldProps = FieldProps;

export const OperationsStaffAgreementInputField = ({
    field,
    value,
    entityForm,
    options,
    extraOptions,
}: OperationsStaffAgreementInputFieldProps) => {
    const fieldName = extraOptions?.field ? extraOptions?.field : field.field;
    let fieldError = entityForm.formState.errors;
    const errorMessage = get(fieldError, fieldName)?.message as string;

    useUrlParamValue(fieldName, entityForm, value);

    return (
        <Controller
            name={fieldName}
            control={entityForm.control}
            defaultValue={value || ""}
            render={({ field: fieldInput }) => (
                <TextField
                    {...fieldInput}
                    fullWidth
                    type="text"
                    label={field.headerName}
                    error={errorMessage ? true : false}
                    helperText={errorMessage}
                    disabled={true}
                />
            )}
        />
    );
};
